
import { request } from "../../../config/helpers/axios-instance";
import { useQuery } from "react-query";


const fetchSupportUsers = () => {
    return useQuery(
        ["get-all-support-users"],
        () =>
            request({
                url: `user/admin/supportUsers`,
                method: "GET",
            })
    );
}



export { fetchSupportUsers };




